import React from 'react';
import Checkbox from '../checkbox/Checkbox';
import './style.css';

export default class PersonalDataCheckbox extends React.Component {

  onChange(e) {
    const isValid = e.target.checked;
    this.props.onChange({
      isValid: isValid
    });
  }

  render() {
    const title = (<span>Подтвердите ваше согласие на обработку персональных данных в соответствии с условиями, указанными <a href='http://bit.ly/7bits-policy-sp' target='_blank' style={{color: 'inherit'}}>по ссылке</a></span>);
    return (
      <Checkbox
        onChangeCallback={this.onChange.bind(this)}
        name='personalData'
        inputId='personalData'
        title={title}
        isSquare={true}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/personal-data-checkbox/PersonalDataCheckbox.js